// extracted by mini-css-extract-plugin
module.exports = {"background":"app_background__3aegv","download-link":"app_download-link__2MQ8C","link-group":"app_link-group__7Kpsg"};